import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { GoogleIntegrationDetails } from './models/google-integration-details';
import HtmlTagFactory from '../structure/google-tag-manager-setup/html-tag-factory';
import { map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class GoogleIntegrationService {
  private baseUrl = `${environment.baseUrl}googleintegration`;

  constructor(private http: HttpClient) { }

  public getDetails(customerId: number): Observable<GoogleIntegrationDetails> {
    return this.http.get<GoogleIntegrationDetails>(`${this.baseUrl}/details/${customerId}`)
      .pipe(map(details => {
        details.gtmNoScriptTag = HtmlTagFactory.generateGtmNoScriptTag(details.gtmId);
        details.gaHtmlTag = HtmlTagFactory.generateGaHtmlTag(details.gaMeasurementId);

        return details;
      }));
  }

  public verifyGtmTag(customerId: number): Observable<boolean> {
    return this.http.post<boolean>(`${this.baseUrl}/verify/${customerId}`, null);
  }
}
